import { Button } from "../../../components/Button";
import { PRAXIS_PLAY_EVENTS } from "../../../integrations/posthog/events";
import { useAnalytics } from "../../../integrations/posthog/useAnalytics";
import { useApp } from "../../../services/app-context";
import { SignedUrlImage } from "../../../components/SignedUrlImage";

export const SALES_EXPERIENCE_OPTION_KEYS = {
    "JUST_STARTING_OUT": "just-starting-out",
    "1_5_YEARS": "1-5-years",
    "6_PLUS_YEARS": "6-plus-years"
}

export const SALES_EXPERIENCE_OPTIONS = {
    [SALES_EXPERIENCE_OPTION_KEYS.JUST_STARTING_OUT]: "Just starting out",
    [SALES_EXPERIENCE_OPTION_KEYS["1_5_YEARS"]]: "1 - 5 years",
    [SALES_EXPERIENCE_OPTION_KEYS["6_PLUS_YEARS"]]: "6+ years"
}


export function Step1_5({ onContinue, onboardingForm, setOnboardingForm }: { onContinue: () => void, onboardingForm: any, setOnboardingForm: any }) {

    const { tenantProfile } = useApp()
    const { captureEvent } = useAnalytics();

    const handleContinue = (level?: string) => {
        if (level) {
            setOnboardingForm({ ...onboardingForm, sales_experience: level });
            captureEvent(PRAXIS_PLAY_EVENTS.SURVEY_EXPERIENCE_LEVEL_SELECTED, {
                experience_level: level,
                experience_display_name: SALES_EXPERIENCE_OPTIONS[level],
                content_type: "onboarding",
            });
        }
        onContinue();
    }

    return (
        <div className="flex items-center gap-10 p-10">
            <div className="flex-[2]">
                <SignedUrlImage s3Key="onboarding-1.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
            </div>
            <div className="flex flex-col gap-4 flex-[3]">
                <div>
                    <div className="flex flex-col gap-2">
                        <span className="text-black text-[21px] font-bold ">Choose your level of
                            professional sales experience</span>
                    </div>
                    <div className="flex flex-col gap-[18px] mt-6">
                        {Object.keys(SALES_EXPERIENCE_OPTIONS).map((key) => (
                            <Button
                                variant="primary"
                                className={`!rounded-full w-[136px] !h-10 !text-text2 border ${onboardingForm?.sales_experience === key ? "!bg-background2 border-primary" : "!bg-[#EEE] border-transparent"} !w-full`}
                                onClick={() => handleContinue(key)}
                            >
                                {SALES_EXPERIENCE_OPTIONS[key]}
                            </Button>
                        ))}

                    </div>
                </div>
            </div>
        </div>
    )
}